
import
{
  styled,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import { colors } from "../../../options/colors";
import SolidButton from "../../Buttons/SolidButton/SolidButton";
import { green } from "@mui/material/colors";

export const Container = styled('div')(() => ({
  position: 'relative',
  display: 'flex',
  border: "1px solid green",
  width: "400px",
  height: "450px"
}));

export const StyledCard = styled(Card)(({ theme, selected, active }) => ({
  padding: "20px 20px 25px",
  background: "rgba(0, 0, 0, 0.4)",
  /* height: "21em", */
  borderRadius: 5,
  display: "flex",
  flexDirection: "column",
  border: selected ? `3px solid ${colors.primaryOrange}` : active ? `3px solid ${colors.primaryGreen}` : `3px solid transparent`,

  [theme.breakpoints.down("sm")]: {
    height: "unset",
    margin: 0,
  },
}));

export const StyledCardActions = styled(CardActions)(() => ({
  padding: 0,
  margin: "auto 0 0",
  textAlign: "center",
}));

export const StyledCardContent = styled(CardContent)(() => ({
  padding: 0,
  marginBottom: 20,
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
}));

export const IconAvatarContainer = styled("div")(() => ({
  marginBottom: 25,
}));

export const FeatureLinesContainer = styled("div")(() => ({
  width: "100%",
}));
